<template>
    <section class="zemlya-cards">
        <div
            class="zemlya-cards__card"
            v-for="item in cardsInfo"
            :key="'zemlya-cards' + item.id"
        >
            <img
                :src="item.props.img_desktop.files[0].src"
                class="zemlya-cards__card-image"
                alt="card-photo"
            />
            <div class="zemlya-cards__card-block">
                <div class="zemlya-cards__card-container">
                    <h3 class="zemlya-cards__card-title">{{ item.props.title.value }}</h3>
                    <p class="zemlya-cards__card-text">{{ item.props.subtitle.value }}</p>
                </div>
                <a 
                    class="zemlya-cards__card-link"
                    :href="item.props.link.value"
                >
                    Подробнее
                </a>
            </div>
        </div>
    </section>
</template>
<script>
import { defineProps } from "vue";

export default {
	name: 'ZemlyaCards',
    props: ['cards-info'],
}
</script>

<script setup>
const props = defineProps(['cards-info']);
const cardsInfo = props.cardsInfo;
</script>